/**
 * @author Ivan Toth.
 */
var DetailValidGeneralController = (function () {
    function DetailValidGeneralController(topic, Dialog, socket, $stateParams, env, settings, $scope, _) {
        var _this = this;
        this.topic = topic;
        this.Dialog = Dialog;
        this.socket = socket;
        this.$stateParams = $stateParams;
        this.env = env;
        this.settings = settings;
        this.$scope = $scope;
        this._ = _;
        this.comp = 'gpp_valid';
        this.comp2 = 'gpp_history';
        this.updateArray = ['gpp_valid', 'gpp_history'];
        this.paSiteVisibe = false;
        this.paSiteEditable = true;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
        var contactEmail = this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5 ?
            this.topic.topic.contactEmail :
            _.get(this.topic.checksData, 'inboundInitial.inbound.incentiveInformation.incentiveDetail.createdBy');
        var oppVersion = _.get(this.topic.checksData, 'uiVersion', 1);
        this.getNewUIInfo = {
            uiVersion: oppVersion,
            email: contactEmail,
            cmr: _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.incentiveCMRNumber'),
            bpCountry: function () {
                var countryShort;
                countryShort = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.country');
                return _this.topic.getCountryFullName(countryShort);
            },
            accountCountry: function () {
                var countryShort;
                countryShort = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrCountryCode');
                return _this.topic.getCountryFullName(countryShort);
            },
            bpName: function () {
                var bpFirstName;
                var bpLastName;
                if (oppVersion && oppVersion <= _this.OPP_VERSION_4) {
                    bpFirstName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.bpFirstName');
                    bpLastName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.bpLastName');
                }
                else {
                    bpFirstName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.bpFirstName');
                    bpLastName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.bpLastName');
                }
                return bpFirstName + " " + bpLastName;
            },
            getSVISumbitDateName: function () {
                return _this.getNewUIInfo.uiVersion >= _this.OPP_VERSION_3
                    ? 'Submit Date:'
                    : 'Submit Date for CVR Eligibility:';
            },
            submitPaymentDate: function () {
                return _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.submitPaymentDate', _this.topic.topic.gpp_valid[0].svi_submit_for_payment_date);
            },
            paymentComments: function () {
                return _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.paymentComments', _this.topic.topic.gpp_valid[0].svicmnt);
            },
            externalLinks: function (link) { return _this.topic.externalLinks[link]; }
        };
    }
    DetailValidGeneralController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailValidGeneralController.prototype.getAccountValue = function (accountName) {
        var generics = _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.generics');
        var accountObj = generics.find(function (generic) { return generic.name === accountName; });
        return accountObj ? accountObj.value : '';
    };
    DetailValidGeneralController.prototype.getDcId = function () {
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrDomesticClientId');
        }
        else {
            return this.getAccountValue('domesticClientId');
        }
    };
    DetailValidGeneralController.prototype.getDbg = function () {
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrDomesticBuyingGroup');
        }
        else {
            return this.getAccountValue('domesticBuyingGroup');
        }
    };
    DetailValidGeneralController.prototype.changePaVisible = function () {
        this.paSiteVisibe = !this.paSiteVisibe;
    };
    DetailValidGeneralController.prototype.changeEditMode = function (action) {
        if (action === 'save' && this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
            console.log('send for update');
            this.topic.sendForUpdateGeneral(this.updateArray, false);
        }
        if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
            this.topic.setTempFromTopicPart(this.comp2);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    /**
     * opens the dialog with selected field and once its confirmed it changes the temp value
     * @param event - in html I'm passing the $event.
     * @param attribute - string -  identifies which fields edit button was pressed
     * @param name - string -  label of the field
     * @param type - string -  's' - menas string value, 'd'- date value (not implemented yet for date)
     */
    DetailValidGeneralController.prototype.updateField = function (event, attribute, name, type) {
        var _this = this;
        this.items = { item: this.topic.topic.gpp_valid[0][attribute], field: name, type: type };
        this.Dialog.updateValidForm(event, this.items, 'dialog-validation.html').then(function (dResult) {
            if (!angular.isUndefined(dResult)) {
                if (dResult.type === 's') {
                    console.log('changing string');
                    _this.topic.temp.gpp_valid[0][attribute] = dResult.value;
                }
                _this.topic.temp.gpp_history.push({
                    updates: name + '(' + dResult.item + ') has been updated',
                    time: (new Date()).getTime(),
                    source: _this.env.user.email,
                    comment: dResult.comment
                });
            }
        });
    };
    ;
    DetailValidGeneralController.prototype.reload = function () {
        this.topic.loaded.gpp_valid = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'refreshValidationGPP',
                script: '/detail/validation/validation',
                opp: this.topic.topic.opp,
                unid: this.topic.topic._id,
                token: this.env.user.token
            }
        });
    };
    DetailValidGeneralController.prototype.isV4OrLess = function () {
        var version = this.topic.topic.version;
        return !version || version <= this.OPP_VERSION_4;
    };
    DetailValidGeneralController.prototype.getRestricted = function () {
        return this.isV4OrLess() ? this.getRestrictedV4() : this.getRestrictedV5();
    };
    DetailValidGeneralController.prototype.getRestrictedV4 = function () {
        switch (_.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.opportunity.isRestricted')) {
            case 'RESTNOT':
                return 'Not Restricted';
            case 'RESTOPCL':
                return 'Restricted to opportunity team, client team and incentive review team';
            case 'RESTOPTY':
                return 'Restricted to opportunity team and incentive review team';
            default:
                return '';
        }
    };
    DetailValidGeneralController.prototype.getRestrictedV5 = function () {
        switch (this.topic.topic.isRestr) {
            case 'N':
                return 'Not Restricted';
            case 'Y':
                return 'Restricted';
            default:
                return '';
        }
    };
    DetailValidGeneralController.prototype.getRevenueV5 = function () {
        if (this.topic.topic.version >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.opportunityAmount');
        }
        return undefined;
    };
    DetailValidGeneralController.prototype.getOppCurrencyV5 = function () {
        if (this.topic.topic.version >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.opportunityCurrency');
        }
        return undefined;
    };
    DetailValidGeneralController.$inject = ['topic', 'Dialog', 'socket', '$stateParams', 'env', 'settings', '$scope', '_'];
    return DetailValidGeneralController;
}());
var DetailValidGeneralComponent = (function () {
    function DetailValidGeneralComponent() {
        this.templateUrl = 'detail-validation-general.html';
        this.controllerAs = 'vm';
        this.controller = DetailValidGeneralController;
    }
    return DetailValidGeneralComponent;
}());
angular
    .module('application')
    .component('detailValidGeneral', new DetailValidGeneralComponent());

//# sourceMappingURL=detail.validation.general.component.js.map
